// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3d925fc9","239":"966eabc9","455":"d0d1b50e"}[chunkId] + ".chunk.js";
};